(function () {
  'use strict';

  angular
    .module('annualLeaveBidding')
    .config(config);

	  function config($stateProvider) {
		$stateProvider.state('annualLeaveBidding', {
			url : '/annual-leave-bidding',
			views : {
				'annualLeaveBiddingView' : {
					templateUrl : 'annual-leave-bidding/views/annual-leave-bidding.tpl.html',
					controller : 'AnnualLeaveBiddingCtrl',
					controllerAs : 'annualLeaveBidding'
				}
			}
		});
	}
}());
